document.querySelectorAll("summary").forEach(item => {
    item.addEventListener("click", function() {
        let details = this.parentElement;
        details.querySelector("summary").setAttribute("aria-expanded", details.open);
    });
});

function showError(message) {
    let errorContainer = document.getElementById("acf-error-message");
    if (errorContainer) {
        errorContainer.textContent = message;
        errorContainer.style.display = "block";
    }
}

document.getElementById("CartDrawer-LiveRegionText").setAttribute("aria-hidden", "false");
 setTimeout(() => {
    document.getElementById("CartDrawer-LiveRegionText").setAttribute("aria-hidden", "true");
}, 1000);

//open wishlist desktop
document.addEventListener("DOMContentLoaded", function() {
    function openWishlist() {
        let wishlistAnchor = document.querySelector('a[href="#swym-wishlist"]');

        if (wishlistAnchor) {
            wishlistAnchor.click(); // Simula el clic en el enlace original
            console.log("✅ Wishlist abierta correctamente.");
        } else {
            console.error("⚠️ No se encontró el enlace #swym-wishlist en el DOM.");
        }
    }

    // Asignar evento a todos los elementos con la clase "trigger-wishlist"
    document.querySelectorAll(".trigger-wishlist, #openWishlist").forEach(item => {
        item.addEventListener("click", openWishlist);
    });

    // Si la app de Wishlist inyecta el enlace después de la carga, observar el DOM
    let observer = new MutationObserver(() => {
        let wishlistAnchor = document.querySelector('a[href="#swym-wishlist"]');
        if (wishlistAnchor) {
            console.log("🔍 Wishlist detectada en el DOM.");
            observer.disconnect(); // Dejar de observar cuando se encuentra
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
});

// THIRD LINK INJECTED 
document.addEventListener("DOMContentLoaded", function() {
    function ensureWishlistExists() {
        let wishlistPopup = document.getElementById("swym-wishlist");

        // Si no existe, lo agregamos oculto para que WAVE no lo marque como error
        if (!wishlistPopup) {
            let fakeWishlist = document.createElement("div");
            fakeWishlist.id = "swym-wishlist";
            fakeWishlist.style.display = "none"; // Oculto para que no afecte el diseño
            document.body.appendChild(fakeWishlist);
            console.log("✅ Se agregó un placeholder para #swym-wishlist para evitar errores en WAVE.");
        }
    }

    // Ejecutar al cargar la página
    ensureWishlistExists();

    // Observar cambios en el DOM (por si la app lo inyecta después)
    let observer = new MutationObserver(() => {
        ensureWishlistExists();
    });

    observer.observe(document.body, { childList: true, subtree: true });
});

//ARIA LABEL DUPLICATED
function updateFirstSearchAriaLabel() {
  const inputs = document.querySelectorAll('input[aria-label="When autocomplete results are available use up and down arrows to review and enter to select"]');
  
  if (inputs.length > 1) {
    // Cambiar solo el primero
    inputs[0].setAttribute('aria-label', 'Search bar. When autocomplete results are available use up and down arrows to review and enter to select');
  }
}


// link recently viewed cart Mobile
function myProduct() {
                e.preventDefault();
                 window.location = "http://www.google.com/";  
              }

